import React, { Component } from 'react';
import { runtime } from 'rest/runtime';
import { WidgetHeader } from './WidgetHeader';

class Widget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      widgetTitle: this.props.widgetTitle || '',
      content: ''
    };

    this.controller = new AbortController()
  }

  componentDidMount() {
    this.setState({widgetTitle: this.makeWidgetTitle()});
    this.addExternalView();

  }

  componentWillUnmount() {
    this.controller.abort()
  }

  makeWidgetTitle() {
    return this.props.widgetId.replace(/_/g, ' ');
  }

  getController() {
    return runtime.currentUser.getDashboardPath();
  }

  addExternalView() {
    fetch('/' + this.getController() + '/' + this.props.widgetId, { signal: this.controller.signal })
      .then((response) => response.text())
      .then((data) => {
        this.setState({content: data});
      }).catch((err) => {
        if (err.name !== "AbortError") {
          console.error(err)
        }
      })
  }

  render() {
    var widgetCloseStyle = {
      float: 'right',
      cursor: 'pointer'
    };
    var widget_id = `ID_${this.props.widgetId}`;
    return (
      <li className="bg-white border m-4 shadow border-gray-400 text-sm" id={widget_id}>
        <WidgetHeader widget={this.props} widgetTitle={this.state.widgetTitle}/>
        <div dangerouslySetInnerHTML={{ __html: this.state.content }}></div>
      </li>
    );
  }
}

export { Widget };
